import "babel-polyfill";

import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux'
import { createStore } from 'redux'
import App from './app/App';
import { unregister } from './registerServiceWorker';
import 'date-input-polyfill'; // IE support for input type=date
import './index.css';
import 'bootstrap/dist/css/bootstrap.min.css';


import rootReducer from './reducers'

const store = createStore(rootReducer)

ReactDOM.render(<Provider store={store}><App /></Provider>, document.getElementById('root'));
unregister();



// WEBPACK FOOTER //
// ./src/index.js